import { Navigate, Route, Routes } from "react-router-dom";
import TagrosProductDetailsPage from "./components/Tagros/ProductDetails/TagrosProductDetailsPage";
import TagrosProductDisplayConfigPage from "./components/Tagros/Config/TagrosProductDisplayConfigPage";
import "./index.css";
import "./App.css";

function App() {
  return (
    <div className="App">
      <Routes>
        <Route path="/tagros/config" element={<TagrosProductDisplayConfigPage />} />
        <Route path="/config" element={<TagrosProductDisplayConfigPage />} />
        <Route path="/Tagros/:sku" element={<TagrosProductDetailsPage />} />
        <Route path="/:token" element={<TagrosProductDetailsPage />} />
      </Routes>
    </div>
  );
}

export default App;

